/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipi di evento calendario. Tipi previsti:   -*PASTA_IN_BIANCO*  -*ANNULLATO*
 */
export enum ServizioMensaEventoCalendarioType {

    PASTA_IN_BIANCO = 'PASTA_IN_BIANCO',

    ASSENZA = 'ASSENZA'
}

